<template>
  <div class="">
    <HelloWorld msg="Welcome to Your Vue.js App" :idreservation="idreservation"/>
    <h1>Pusher Test</h1>
  <p>
    Try publishing an event to channel <code>my-channel</code>
    with event name <code>my-event</code>.
  </p> 
  </div>

</template>

<script>

// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'


export default {
  name: 'Home',
  props:['idreservation'],
  components: {
    HelloWorld,
  },
  created () {
    // ...
    this.subscribe()
  },
  methods: {
    // ...
    subscribe () {

    }
  },
}
</script>
